/* PIX storefront behaviour. Loaded with defer from the sections that need it. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('pix-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pix-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    [].forEach.call(document.querySelectorAll('.pix-rev:not(.pix-in)'), function (el) { io.observe(el); });
  }

  function initDock() {
    var dock = document.querySelector('[data-pix-dock]');
    if (!dock) return;
    var hero = document.querySelector('[data-pix-hero]');
    var batch = document.querySelector('[data-pix-batch]');
    function sync() {
      var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : scrollY > 600;
      var onBatch = false;
      if (batch) {
        var r = batch.getBoundingClientRect();
        onBatch = r.top < innerHeight * 0.75 && r.bottom > 0;
      }
      dock.classList.toggle('pix-on', pastHero && !onBatch);
    }
    var queued = false;
    addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }, { passive: true });
    addEventListener('resize', sync, { passive: true });
    sync();
  }

  function boot() { initReveal(); initDock(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Re-run when the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', boot);
})();
